import { render, staticRenderFns } from "./answers.vue?vue&type=template&id=5af1c2c9"
import script from "./answers.vue?vue&type=script&lang=js"
export * from "./answers.vue?vue&type=script&lang=js"
import style0 from "./answers.vue?vue&type=style&index=0&id=5af1c2c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports